// 面包屑配置类型
export interface BreadcrumbConfig {
  title: string | (() => string) // 支持动态标题函数
  path: string
  parent?: string // 父级路径
}

// 路由配置映射
export const BREADCRUMB_CONFIG: Record<string, BreadcrumbConfig> = {
  '/': {
    title: '首页',
    path: '/',
  },
  '/agents': {
    title: '智能体中心',
    path: '/agents',
  },
  '/agents/list': {
    title: '智能体中心',
    path: '/agents/list',
  },
  '/agents/add': {
    title: '新建',
    path: '/agents/add',
    parent: '/agents',
  },
  '/agents/edit': {
    title: '编辑',
    path: '/agents/edit',
    parent: '/agents',
  },
  '/agents/publish': {
    title: '发布',
    path: '/agents/publish',
    parent: '/agents',
  },
  '/agents/chat': {
    title: () => {
      // 动态获取智能体名称
      return '智能体名称'
    },
    path: '/agents/chat',
    parent: '/agents',
  },
  '/agents/chat/session': {
    title: () => {
      // 动态获取会话名称
      return '会话名称'
    },
    path: '/agents/chat/session',
    parent: '/agents/chat',
  },
  '/knowledge/list': {
    title: '知识库',
    path: '/knowledge/list',
  },
  '/knowledge': {
    title: '知识库',
    path: '/knowledge',
  },
  '/users': {
    title: '用户管理',
    path: '/users',
  },
  '/settings': {
    title: '组织架构',
    path: '/settings',
  },
  '/workspace': {
    title: '空间成员和设置',
    path: '/workspace',
  },
  '/workspace/member': {
    title: '人员管理',
    path: '/workspace/member',
    parent: '/workspace',
  },
  '/workspace/setting': {
    title: '设置',
    path: '/workspace/setting',
    parent: '/workspace',
  },
  '/knowledge/dataset': {
    title: () => {
      // 这里返回一个函数，实际标题会在 Breadcrumb 组件中动态获取
      return '数字知识库'
    },
    path: '/knowledge/dataset',
    parent: '/knowledge/list',
  },
  '/knowledge/dataset-import': {
    title: '添加内容',
    path: '/knowledge/dataset-import',
    parent: '/knowledge/dataset',
  },
  '/knowledge/dataset-detail': {
    title: '数据集详情',
    path: '/knowledge/dataset-detail',
    parent: '/knowledge/dataset',
  },
  '/dashboard': {
    title: '仪表盘',
    path: '/dashboard',
  },
  '/workspace/apps': {
    title: '应用管理',
    path: '/workspace/apps',
    parent: '/workspace',
  },
  '/organization': {
    title: '组织结构',
    path: '/organization',
  },
  '/organization/list': {
    title: '组织结构',
    path: '/organization/list',
  },
  '/organization/details': {
    title: '组织结构',
    path: '/organization/details',
    parent: '/organization/list',
  },
}

// 获取面包屑配置
export const getBreadcrumbConfig = (
  path: string
): BreadcrumbConfig | undefined => {
  return BREADCRUMB_CONFIG[path]
}

// 根据路径生成面包屑路径数组
export const generateBreadcrumbPath = (path: string): string[] => {
  const paths: string[] = []
  let currentPath = path

  // 特殊处理智能体聊天路由
  if (path.startsWith('/agents/chat/')) {
    // 如果是智能体聊天会话页面
    if (path.includes('/agents/chat/s/')) {
      paths.push('/agents')
      paths.push('/agents/chat')
      paths.push('/agents/chat/session') // 添加会话页面配置
    } else {
      // 如果是智能体聊天欢迎页面
      paths.push('/agents')
      paths.push('/agents/chat')
    }
    return paths
  }

  // 特殊处理智能体编辑路由
  if (path.startsWith('/agents/edit/')) {
    paths.push('/agents')
    paths.push('/agents/edit')
    return paths
  }

  // 特殊处理智能体新建路由
  if (path === '/agents/add') {
    paths.push('/agents')
    paths.push('/agents/add')
    return paths
  }

  while (currentPath) {
    paths.unshift(currentPath)
    const config = getBreadcrumbConfig(currentPath)
    currentPath = config?.parent || ''
  }

  return paths
}
